import React, { ReactElement } from "react";
import { IconType } from "react-icons";

import { ButtonProps } from "@mui/material/Button";

import { StyledButton, ButtonLoader } from "./style";

export interface Props extends ButtonProps {
  small?: boolean
  fullwidth?: boolean
  label?: string | number | IconType
  leftLabel?: string | number | IconType | ReactElement
  rightLabel?: string | number | IconType
  isLoading?: boolean
  disabled?: boolean
  leftLabelSize?: number
  rightLabelSize?: number
  iconSize?: "small" | "medium" | "large",
  size?: "small" | "medium" | "large"
  dataClarityMask?: "True" | "False"
}

const renderTextOrSVG = (
  value: string | number | IconType | ReactElement,
  iconSize?: number,
) => {
  if (typeof value === "function") {
    const Icon = value;
    return <Icon style={{ fontSize: iconSize }} />;
  }
  return value;
};

export default function Button({
  label = "",
  leftLabel = "",
  rightLabel = "",
  isLoading = false,
  disabled = false,
  leftLabelSize = 22,
  size = "medium",
  dataClarityMask,
  rightLabelSize = 22,
  ...rest
}: Props) {
  return (
    <StyledButton
      type="button"
      data-clarity-mask={dataClarityMask}
      size={size as any}
      hasLeftLabel={Boolean(leftLabel)}
      hasRightLabel={Boolean(rightLabel)}
      disabled={disabled || isLoading}
      {...rest}
    >
      {leftLabel && <span style={{marginRight: "8px"}}>{leftLabel && renderTextOrSVG(leftLabel, leftLabelSize)}</span> }
      <span>{renderTextOrSVG(label)}</span>
      {isLoading && <ButtonLoader />}
      {rightLabel &&  <span style={{marginLeft: "8px"}}>{renderTextOrSVG(rightLabel, rightLabelSize)}</span>}
    </StyledButton>
  );
}
